<div class="d-flex bg-body-tertiary INN-h100vh">
    <main class="form-report w-100 m-auto rounded-4">
        <iframe [title]="'Factura Ágil Reporte'" [width]="'1140'" [height]="'541.25'" [src]="powerBiUrlDSI" frameborder="0" allowFullScreen="true"></iframe>
    </main>
</div>